import * as React from 'react';
import { ArticleParagraph1, Responsive, UIText2, IconSuccess16 } from '@cian/ui-kit';

import { ESortType } from '../../../types/sort';
import * as style from './style.css';

export interface IReviewSortItemProps {
  type: ESortType;
  title: string;
  isSelected: boolean;
  onClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ReviewSortItem: React.FC<IReviewSortItemProps> = ({ type, title, isSelected, onClick }) => {
  return (
    <label htmlFor={title} className={style['label']}>
      <input type="radio" name="reviews-sort" id={title} value={type} onChange={onClick} />

      <div className={style['title']}>
        <Responsive desktop>
          <UIText2 color="black_100">{title}</UIText2>
        </Responsive>

        <Responsive phone tablet>
          <ArticleParagraph1 color="black_100">{title}</ArticleParagraph1>
        </Responsive>

        {isSelected && <IconSuccess16 color="primary_100" />}
      </div>
    </label>
  );
};
